import { render, staticRenderFns } from "./TrEx.vue?vue&type=template&id=4586f8d6&scoped=true&"
import script from "./TrEx.vue?vue&type=script&lang=js&"
export * from "./TrEx.vue?vue&type=script&lang=js&"
import style0 from "./TrEx.vue?vue&type=style&index=0&id=4586f8d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4586f8d6",
  null
  
)

export default component.exports